import { ui } from '../../styles/ui'

export default function PageShell({ className = '', children }) {
  const wrapperClass = ui?.layout?.pageWrapper || ui?.page || 'w-full space-y-4'
  return <div className={`${wrapperClass} ${className}`.trim()}>{children}</div>
}
